import {FC} from 'react';

import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import {Typography} from '@mui/material';

interface ITableToolbar {
  loadingState: 'hasValue' | 'hasError' | 'loading';
}

export const TableToolbar: FC<ITableToolbar> = ({loadingState}) => {
  return (
    <Toolbar
      sx={{
        pl: {sm: 2},
        pr: {xs: 1, sm: 1},
        justifyContent: 'space-between',
      }}
    >
      <Stack direction="column" width="100%" spacing={1}>
        <Stack direction="row" paddingY={2} justifyContent="flex-start">
          <Typography variant="subtitle1">История изменений</Typography>
        </Stack>
      </Stack>
    </Toolbar>
  );
};
